import { getStore } from '~/mobx/AppStore';

const getSelectedElectionYear = (): number => {
    const { generalSettingsStore } = getStore();
    const { selectedElectionData } = generalSettingsStore;

    const electionStartDate =
        selectedElectionData?.election_start_date ??
        selectedElectionData?.attributes?.find((attr) => attr.number === 'election_start_date')?.value;

    if (!electionStartDate) {
        return 0;
    }

    const dateObj = new Date(electionStartDate);
    const fullYear = !isNaN(dateObj.getTime()) ? dateObj.getFullYear() : 0;
    return fullYear;
};

export default getSelectedElectionYear;
